import { useQuery } from '@tanstack/react-query';

import { fetchBillingNotes } from '../api/FetchBillingNotes';

export function useBillingNotes(billingUuid: string | undefined) {
  const { data, isLoading, isError, refetch } = useQuery({
    queryKey: ['billing-notes', billingUuid],
    queryFn: () => fetchBillingNotes(billingUuid!),
    enabled: !!billingUuid,
  });

  return { notes: data, isLoading, isError, refetch };
}
